module.exports = __webpack_public_path__ + "static/media/image 27.cf765ad4.png";